import { mapState } from 'vuex'
import { existHierarchy } from '../plugins/helpers'
export default {
  computed: {
    ...mapState(['id_comissionado_venda', 'id_ponto_venda', 'hierarquia_comercial']),

    getPayloadGenericoFiltrarVendas () {
      const is_user_hierarquia = existHierarchy(this.hierarquia_comercial)
      const id_comissionado_venda = this.id_comissionado_venda
      const id_ponto_venda = this.id_ponto_venda

      let filtros = {
        id_comissionado_venda,
        is_user_hierarquia,
        id_ponto_venda,
        loginGerenteNegocio: null,
        estruturaComercialSelecionada: null,
        idEstruturaComercial: null
      }

      if (is_user_hierarquia) {
        filtros.loginGerenteNegocio = this.hierarquia_comercial.gerenteNegocioSelecionado.codigoUsuario
        filtros.estruturaComercialSelecionada = this.hierarquia_comercial?.estruturaComercialSelecionada?.codigoEstruturaComercialCompleta ?? null
        filtros.idEstruturaComercial = this.hierarquia_comercial?.estruturaComercialSelecionada?.idEstruturaComercial ?? null
      }

      return filtros
    }
  },
  methods: {
    resetarFlavorPorAmbiente () {
      const ambienteOriginal = this.$session.get('ambiente_original')
      if (ambienteOriginal) {
        this.$session.set('trocando_ambiente', false)
        this.$session.set('flavor', ambienteOriginal.nm_flavor)
        this.$session.set('ambiente', ambienteOriginal)
        this.$session.set('id_empresa', ambienteOriginal.id_empresa_newcon)
        this.$session.set('sinalMudarIdentidadeVisual', true)
      }
    }
  }

}
